import { render, staticRenderFns } from "./wew-footer-white.vue?vue&type=template&id=0c87effe&"
var script = {}
import style0 from "./wew-footer-white.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wew-footer-white.vue"
export default component.exports